import initTheme from "./scripts/theme";
import initChat from "./scripts/chat";
import initFit from "./scripts/fit";
// CV page: one scrollable page for recruiters, printable

initTheme();
initChat();
initFit();

for (const button of document.querySelectorAll("[data-print]")) {
  button.addEventListener("click", () => window.print());
}
